import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../../core/services/general.service';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { MobileDelegateService } from '../../../core/services/mobile-delegate.service';
import { MobileWebViewService } from '../../../core/services/mobile-web-view.service';
import { RouteTrackerService } from '../../../core/services/route-tracker.service';
import { ScreenManagerService } from '../../../core/services/screen-manager.service';
import { DelegateType } from '../../../shared/models/utility.model';

import { SIDE_NAV_BREAK_POINT } from '../../../shared/constants';

declare const closeZendeskWidget: any;
declare const openWidget: any;

@Component({
	selector: 'app-need-help',
	templateUrl: './need-help.component.html',
	styleUrls: ['./need-help.component.scss'],
})
export class NeedHelpComponent implements OnInit {
	isMobile: boolean;
	title = 'Need Help?';
	description = 'Select how you want us to help you';
	backButton = 'Help';
	isMobileWebUser: boolean;
	showCloseButton = false;
	isSideNavOpen: boolean;
	loadingDashboard: boolean;
	@Input() visible: any;
	@Output() closeMenu: EventEmitter<any> = new EventEmitter();
	faqs = [
		{
			question: "I don't remember my BVN. What do I do?",
			answer: 'Dial <b>*565*0#</b> on your registered phone number to get your BVN',
		},
		{
			question: 'My BVN verfiication failed. What do I do?',
			answer: `BVN verification typically fails when you do not provide the right date of birth.
			<div class='mt-[10px]'>Confirm the date of birth on your BVN and try again. If this doesn't work for you, kindly send us a chat or send an email to <b>support@moniepoint.com</b></div>`,
		},
		{
			question: 'My phone number already exists. What do I do?',
			answer: `This means that a Moniepoint account has been created with this phone number.

			<div class='mt-[10px] mb-[10px]'>At this point, you have two options.</div>

			<div>A. Continue signing up using a new phone number</div>
			<div>B. Sign in to your Moniepoint account with your current phone number.</div>`,
		},
		{
			question: 'The username I want is taken. What do I do?',
			answer: `
			Your username is a special name which is used to identify your account on Moniepoint.

			<div class='mt-[10px]'>Avoid using common words such as your first name, last name, etc. Instead, use a combination of words and numbers.<div>
			`,
		},
		{
			question: 'My identity verification failed. What do I do?',
			answer: `Your identity verification fails when we are not able to confirm that you are the true owner of the identity information provided to us.

			<div class='mt-[10px] mb-[10px]'>To fix this, try again by</div>

			<div>1. Ensuring that you submit valid information and documents.</div>
			<div>2. Rotate your head twice during the liveness check.</div>

			<div class='mt-[10px]'>If this doesn't work for you, kindly send us a chat or send an email to <b>support@moniepoint.com</b></div>`,
		},
		{
			question: "I can't sign up. I need help from someone.",
			answer: `Kindly send us a chat or send an email to <b>support@moniepoint.com</b>`,
		},
	];

	constructor(
		private screenManagerService: ScreenManagerService,
		private delegateService: MobileDelegateService,
		private mobileService: MobileWebViewService,
		private localStorage: LocalStorageService,
		public router: Router,
		public generalService: GeneralService,
		private routeHistory: RouteTrackerService
	) {}

	ngOnInit(): void {
		this.setMobileUser();
		this.setIsMobileUser();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event): void {
		this.setMobileUser();
	}

	setMobileUser() {
		this.isMobile = window.innerWidth <= SIDE_NAV_BREAK_POINT;
		if (!this.isMobile || !this.isMobileWebUser) {
			this.buildSideNav();
		}
	}

	buildSideNav() {
		const params = {
			needHelp: true,
		};
		this.generalService.callNeedHelpObervable(params);
	}

	goBack() {
		this.router.navigateByUrl(this.routeHistory.getRoutes()?.previousRoute);
	}

	openWhatsapp() {
		const code = '2349088430803';
		if (this.isMobile) {
			try {
				this.delegateService
					.setDelegateData(DelegateType.launchWhatsApp, code)
					.then((res) => {
						if (!res) {
							console.log('error from whatsapp delegate');
						}
					})
					.catch((error) => {
						this.openWhatsappOnBrowser(code);
					});
			} catch (error) {
				this.openWhatsappOnBrowser(code);
			}
		} else {
			this.openWhatsappOnBrowser(code);
		}
	}

	openWhatsappOnBrowser(code) {
		if (!this.isMobile) {
			window.open(`https://wa.me/+${code}/`, '_blank');
		}
	}

	setIsMobileUser() {
		this.isMobileWebUser = this.mobileService.isMobileWebViewUser();
	}

	openChat($event) {
		this.showCloseButton = true;
		$event?.preventDefault();
		const token = this.localStorage.get('zen_desk_access_token');
		openWidget(token);
	}

	closeWidget() {
		closeZendeskWidget();
		this.showCloseButton = false;
	}

	close() {
		this.closeMenu.emit();
	}

	openSupport() {
		if (this.isMobile) {
			try {
				this.delegateService
					.setDelegateData(DelegateType.launchSupportWebsite)
					.then((res) => {
						if (!res) {
							this.openSupportOnBrowser();
						}
					})
					.catch((error) => {
						this.openSupportOnBrowser();
					});
			} catch (error) {
				this.openSupportOnBrowser();
			}
		} else {
			this.openSupportOnBrowser();
		}
	}

	openSupportOnBrowser() {
		if (!this.isMobile) {
			window.open('https://support.moniepoint.com/', '_blank');
		}
	}
}
